import { Icon } from '@smartgift/frontend-toolkit';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

function Tags({ tags, hideTagsTitle = false, handlePaste }) {
  const { t } = useTranslation();
  const [showDropdown, setShowDropdown] = useState(false);

  const dropdownItems = tags.map((tag, index) => (
    <S.DropdownItem
      variant="caption1"
      key={index.toString()}
      onClick={() => {
        handlePaste({
          text: tag.placeholder
        });
      }}
    >
      {tag.name}
    </S.DropdownItem>
  ));

  return (
    <S.TagArea>
      <Icon name="tag" size="sm" color="currentColor" />
      <S.TagAreaBody
        onClick={() => {
          setShowDropdown(prev => !prev);
        }}
      >
        {!hideTagsTitle && t('insertDynamicRecipientName')}
        <Icon name="down-chevron" color="var(--color-accent-primary-default)" size="sm" />
        {showDropdown && <S.TagAreaDropdown>{dropdownItems}</S.TagAreaDropdown>}
      </S.TagAreaBody>
    </S.TagArea>
  );
}

export { Tags };
